import ZoomInIcon from "@mui/icons-material/ZoomIn";

export const ZoomToolConfig = {
  name: "ZOOM",
  tool: "Zoom",
  icon: <ZoomInIcon />,
};